import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import Exposure from './Exposure';
import ExposureBySettingType from './ExposureBySettingType';
import ExposureBySubsidyAcceptance from './ExposureBySubsidyAcceptance';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row1() {
  const [familyType, setFamilyType] = useState('All');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <SubquestionBox color={lightColor}>
        <Grid container spacing={2}>

          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              Child Care Programs in High-Risk Locations, by Setting and Subsidy
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={6}>
                <MessageBox>
                  <ErrorBoundary>
                    <Exposure />
                  </ErrorBoundary>
                </MessageBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} align="center">
            <ErrorBoundary>
              <ExposureBySettingType height={240} />
            </ErrorBoundary>
          </Grid>
          <Grid item xs={12} sm={6} align="center">
            <ErrorBoundary>
              <ExposureBySubsidyAcceptance height={240} />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </SubquestionBox>
    </FiltersContext.Provider>
  );
}

export default Q1Row1;
